import React from "react";
import ProjectService from "../services/projects";
import ProjectList from "../components/projects/projectlist";
import ClientService from "../services/clients";

import Search from "../components/general/search";
import ProjectEdit from "../components/projects/projectedit";
import ActionButton from '../components/layout/actionButtons';



class Projects extends React.Component {
  constructor(props) {
    super(props);
    this.state = { items: [], filterItems: [], item: undefined, clients: [] };
  }


  componentDidMount() {

    this.getItems();

    if (!this.props.match.params.id) {

      this.props.handleMenu(
        {
          title: 'Projecten',
          handleActions: <ActionButton {...this.props} linkNewItem='/projects/0'></ActionButton>
        })

    } else {
      ClientService.get().then(
        clients => {
          this.setState({ clients: clients.sort(this.compare) });
        }
      )
      if (this.props.match.params.id === '0') {
        this.setState({ item: {} })
      } else {
        ProjectService.get(this.props.match.params.id).then(
          (result) => {
            this.setState({ item: result });
          },
          (err) => {
            this.props.handleMessage({ title: "Kan de gegevens niet ophalen" });
            this.props.history.push('/projects')
          }
        )
      }

      this.props.handleMenu(
        {
          title: 'Project',
          showBackButton: true,
          handleActions: <ActionButton {...this.props} handleSave={this.handleSave}></ActionButton>
        })
    }
  }

  getItems() {
    ProjectService.get().then(
      projects => {
        ClientService.get().then(
          clients => {
            this.setState({ items: projects, filterItems: projects, clients: clients.sort(this.compare) });
          }
        )
      },
      error => {
        console.log("error", error);
      }
    );
  }

  handleUpdate = (item) => {
    this.setState({ item: item });
  }

  handleSave = () => {
    let item = this.state.item;
    console.log(item)
    if (item.name && item.type && item.client) {
      item.projectnumber =  item.projectnumber.trim();
      ProjectService.save(item).then(
        result => {
          this.props.history.push('/projects')
        },
        error => {
          this.props.handleMessage({ title: "Het opslaan is mislukt" });
        }
      );
    } else {
      this.props.handleMessage({ title: "Gegevens zijn niet compleet" });
    }
  }

  handleDelete(item) {
    ProjectService.delete(item._id).then(
      result => {
        this.props.history.push('/projects');
      },
      error => {
        this.props.handleMessage({ title: "Fout bij het verwijderen." });
      }
    );
  }

  handleEdit = (item) => {
    this.props.history.push('/projects/' + item._id);
  }

  handleSearch = (search) => {
    let filterItems = this.state.items;
    filterItems = filterItems.filter((item) => { return (JSON.stringify(item).toLowerCase().indexOf(search.toLowerCase()) >= 0) });
    this.setState({ filterItems })
  }
  compare(a,b) {
    if (a.name < b.name)
      return -1;
    if (a.name > b.name)
      return 1;
    return 0;
  }
  compareNr(a,b) {
    if (a.projectnumber > b.projectnumber)
      return -1;
    if (a.projectnumber < b.projectnumber)
      return 1;
    return 0;
  }
  render() {
    return (
      <div>
        {
          this.state.item
            ?
            <ProjectEdit
              {...this.props}
              item={this.state.item}
              items={this.state.items}
              clients={this.state.clients}
              handleUpdate={this.handleUpdate}
            />
            :
            <React.Fragment>
              <Search handleSearch={this.handleSearch} />
              <ProjectList items={this.state.filterItems.sort(this.compareNr)} handleClick={this.handleEdit} />
            </React.Fragment>
        }
      </div>
    );
  }
}
export default Projects;
